module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("新增首页分类")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "categoryForm",
    attrs: {
      "model": _vm.categoryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择要显示的分类",
      "label-width": "150px",
      "prop": "catogrey"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    on: {
      "change": _vm.catogreyChoose
    },
    model: {
      value: (_vm.categoryForm.catogrey),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "catogrey", $$v)
      },
      expression: "categoryForm.catogrey"
    }
  }, _vm._l((_vm.catogreyArr), function(item) {
    return (item.isOnline) ? _c('el-option', {
      key: item.categoryId,
      attrs: {
        "label": item.name,
        "value": item.categoryId
      }
    }) : _vm._e()
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "150px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b2676f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/AddCategory.vue
// module id = 738
// module chunks = 1